export default __webpack_public_path__ + "static/media/deposit.417391ab.svg";